import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getWeeklyAvailabilities,
  selectAvailabilities,
} from "app/redux/availabilitiesSlice";
import { EmployeesSliceState } from "app/redux/employeesSlice";

export const useStaffHours = ({
  selectedEmployee,
}: {
  selectedEmployee: EmployeesSliceState;
}) => {
  const dispatch = useDispatch();

  const availabilities = useSelector(selectAvailabilities);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchAvailabilities = async () => {
    if (!selectedEmployee?.id) return;

    try {
      setIsLoading(true);
      await dispatch(
        getWeeklyAvailabilities({ employeeId: selectedEmployee.id }) as any
      ).unwrap();
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailabilities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmployee?.id]);

  return {
    availabilities,
    isLoading,
    error,
    fetchAvailabilities,
  };
};
